import { useEffect, useState } from "react";
import { collection, getDocs } from "firebase/firestore";
import { db } from "../firebase-config";
import { Link } from "react-router-dom";

export default function CertificationsList() {
  const [certifications, setCertifications] = useState([]);

  useEffect(() => {
    const fetchCertifications = async () => {
        const snapshot = await getDocs(collection(db, "certifications"));
        const data = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));

        // Separate completed vs in-progress
        const completed = data.filter(c => c.status === true)
        const inProgress = data.filter(c => c.status === false)

        // Sort completed by issueDate (newest first)
        completed.sort((a, b) => {
            const dateA = a.issueDate?.toDate ? a.issueDate.toDate() : new Date(0);
            const dateB = b.issueDate?.toDate ? b.issueDate.toDate() : new Date(0);
            return dateB - dateA;
        });

        // merge lists: completed first, then in-progress
        setCertifications([...completed, ...inProgress]);
    };

    fetchCertifications();
  }, []);

  return (
    // <section className="certificationsList">
    <section className="certificationsList card">
        <h3>Certifications</h3>
        <Link to="/certifications">
            {certifications.map(cert => {
                // removes "Salesforce Certified " from titles of credentials 
                const cleanTitle = cert.title.replace(/^Salesforce Certified */,"")

                // In-progess certifications
                if (cert.status === false) {
                    return (
                        <p key={cert.id}>
                            {cleanTitle} - <span className="inProgress">In Progress</span>
                        </p>
                    );
                }
                
                // ELSE (completed certs)
                const issueDate = cert.issueDate?.toDate
                    ? cert.issueDate.toDate().toLocaleDateString()
                    : "No date available";
                return (
                    <p>
                        {cleanTitle} - <span className="issueDate">{issueDate}</span>
                    </p>
                )
            })}
        </Link>
    </section>
  );
}